import React, { useEffect, useRef } from 'react'
import { Route, Switch, Redirect, useHistory } from 'react-router-dom'
import ReactGA from 'react-ga'

import { PrivateRoute, PublicRoute } from './routing_helpers'

// import { withMainErrorBoundary } from '../../boundaries/main'

import { SessionContextProvider } from '../../contexts/SessionContext'

import Header from '../Header'

import Transcription from '../Transcription'

import NotFound from '../NotFound'
import Login from '../Login'
import Signup from '../Signup'
import ForgotPassword from '../ForgotPassword'
import Billing from '../Billing'

const TranscriptionSection: React.FC = () => (
  <Switch>
    <PrivateRoute exact path="/transcript">
      <Transcription.Jobs />
    </PrivateRoute>
    <PrivateRoute exact path="/transcript/jobs/:jobId">
      <Transcription.JobDetails />
    </PrivateRoute>

    <Route component={NotFound} />
  </Switch>
)

const App: React.FC = () => {
  const history = useHistory()
  const historyRef = useRef(history)

  useEffect(() => {
    const unlisten = historyRef.current.listen((location: any) => {
      ReactGA.pageview(location.pathname + location.search)
    })

    return () => {
      unlisten()
    }
  }, [ historyRef ])

  return (
    <SessionContextProvider>
      <Switch>
        <Route exact path="/">
          <Redirect to="/transcript" />
        </Route>
        <Route path="/transcript">
          <Header baseUrl={"/transcript"} />
          <main>
            <TranscriptionSection />
          </main>
        </Route>

        <PublicRoute exact path="/login">
          <Login />
        </PublicRoute>
        <PublicRoute exact path="/forgot-password">
          <ForgotPassword />
        </PublicRoute>
        <PublicRoute exact path="/signup">
          <Signup />
        </PublicRoute>

        <PrivateRoute exact path="/billing">
          <Header baseUrl={"/transcript"} />
          <main>
            <Billing />
          </main>
        </PrivateRoute>

        <Route>
          <NotFound />
        </Route>
      </Switch>
    </SessionContextProvider>
  )
}

export default App
